import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCardTitle, CFormLabel, CFormSelect, CModal, CModalBody, CModalFooter, CTooltip, CModalHeader, CModalTitle, CHeader, CFormInput } from '@coreui/react'
import React, { useEffect, useState, useRef, lazy, Suspense } from 'react'
import ModalFormBuilder from './ModalFormBuilder'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'

import Select from 'react-select'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info } from 'lucide-react'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import DisplayQuestion from '../../components/shared/DisplayQuestion'
import CheckOptionSelections from '../../components/shared/CheckOptionSelections'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { Spinner } from 'react-bootstrap'
import { SaveActivity } from './save-activity'
import './CustomFormBuilder.css'

const HeaderPlugin = lazy(() => import('../../components/shared/HeaderPlugin'))

const CustomFormBuilder = ({ componentType, componentDiagnosis }) => {
  const [isModalOpen, setIsOpenModal] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [allQuestions, setAllQuestions] = useState([])
  const [fetchedQuestions, setFetchedQuestions] = useState([])
  const [viewQuestions, setViewQuestions] = useState(false)
  const [newQuestions, setNewQuestions] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(componentDiagnosis || null)
  const [selectedEditDiagnosisQuestion, setSelectedEditDiagnosisQuestion] = useState(null)
  const [selectedEditDiagnosisQuestionIndex, setSelectedEditDiagnosisQuestionIndex] = useState(null)
  const [draggedIndex, setDraggedIndex] = useState(null)
  const [callAddFromMade, setCallAddFromMade] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [questionType, setQuestionType] = useState('')
  const [deleteQuestionIndex, setDeleteQuestionIndex] = useState(null)
  const [linkedOptions, setLinkedOptions] = useState({})
  const [selectComponentType, setSelectComponentType] = useState(componentType || [])
  const [componentOption, setComponentOption] = useState([])
  const [copyModelVisible, setCopyModelVisible] = useState(false)
  const [copyType, setCopyType] = useState(null)
  const [copyDiagnosis, setCopyDiagnosis] = useState(null)
  const [fetchCopyQuestion, setFetchCopyQuestion] = useState([])
  const [linkedQuestions, setLinkedQuestions] = useState({})
  const [editHeaderPluginValue, setEditHeaderPluginValue] = useState({})
  const [showHeaderModel, setShowHeaderModel] = useState(false)

  const [pluginType, setPluginType] = useState('Header')
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const urlDiagnosis = queryParams.get('diagnosis')
  const urlType = queryParams.get('type')
  //  const [mode, setMode] = useState("Add")
  const mode = useRef('Add')
  const [inputValues, setInputValues] = useState({})
  const handleInputChange = (e, id) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      [id]: e.target.value,
    }))
  }
  const [selectedCopyOptions, setSelectedCopyOptions] = useState([])
  const [copyOptions, setCopyOptions] = useState([])
  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)

    if (componentType?.value == 'Call Center') {
      setComponentOption([{ value: 'Call Center', label: 'Call Center' }])
    } else {
      setComponentOption([
        { value: 'HPI', label: 'HPI Question' },
        { value: 'followup', label: 'Subjective Question' },
        { value: 'Incident', label: 'Incident Question' },
        { value: 'PhysicalExamination', label: 'Physical Examination' },
      ])
    }
  }

  const GetFormDataForDiagnosis = async () => {
    let formattedData
    formattedData = await SaveQuestionProvider('GET', '', selectComponentType.value, selectedDiagnosis?.value?.toString(), '')

    if (formattedData) {
      formattedData = JSON.parse(formattedData.d)?.Data || []

      formattedData = formattedData[0] || []
      if (formattedData.questionData) {
        formattedData = {
          ...formattedData,
          questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
        }
      }
      setFetchedQuestions(formattedData)
    }
  }
  useEffect(() => {
    if (selectedDiagnosis) {
      GetFormDataForDiagnosis()
    }
  }, [selectedDiagnosis, selectComponentType])

  useEffect(() => {
    getData()
    if (urlDiagnosis && urlType) {
      const fetchDiagnosis = urlDiagnosis ? JSON.parse(decodeURIComponent(urlDiagnosis)) : null
      const fetchType = urlType ? JSON.parse(decodeURIComponent(urlType)) : null
      setSelectedDiagnosis(fetchDiagnosis)
      setSelectComponentType(fetchType)
    }
  }, [])

  const addFormMade = async (headerPlugin = []) => {
    if (Object.entries(fetchedQuestions).length > 0) {
      if (selectedEditDiagnosisQuestion) {
        if (headerPlugin.length > 0) {
          const updateHeaderData = fetchedQuestions?.questionData?.map((item) => {
            if (item.id === headerPlugin[0]?.id) {
              return headerPlugin[0]
            } else {
              return item
            }
          })
          await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify(updateHeaderData))

          setEditHeaderPluginValue({})
          GetFormDataForDiagnosis()
          setAllQuestions([])
          setSelectedEditDiagnosisQuestion(null)
        } else {
          await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify([...fetchedQuestions.questionData]))
        }
      } else {
        if (headerPlugin.length > 0) {
          await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify([...fetchedQuestions.questionData, ...headerPlugin]))
        } else {
          await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify([...fetchedQuestions.questionData, ...allQuestions]))
        }
        GetFormDataForDiagnosis()
        setAllQuestions([])
      }
    } else {
      if (headerPlugin.length > 0) {
        await SaveQuestionProvider('INSERT', '', selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify(headerPlugin))
      } else {
        await SaveQuestionProvider('INSERT', '', selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify(allQuestions))
      }

      GetFormDataForDiagnosis()
      setAllQuestions([])
    }
  }

  const handleDragStart = (e, idx) => {
    e.dataTransfer.setData('questionIndex', idx)
  }

  const handleDrop = (e, idx) => {
    const draggedQuestionIndex = e.dataTransfer.getData('questionIndex')
    if (draggedQuestionIndex === idx) return // Prevent reordering the same item

    const reorderedQuestions = [...fetchedQuestions.questionData]
    const [draggedQuestion] = reorderedQuestions.splice(draggedQuestionIndex, 1)
    reorderedQuestions.splice(idx, 0, draggedQuestion)

    setFetchedQuestions((prevState) => ({
      ...prevState,
      questionData: reorderedQuestions,
    }))
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  if (callAddFromMade == true) {
    addFormMade()
    setCallAddFromMade(false)
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const deleteQuestion = async (idx) => {
    try {
      setFetchedQuestions((prevState) => ({
        ...prevState,
        questionData: prevState.questionData.filter((_, i) => i !== idx),
      }))
      const updatedQuestions = fetchedQuestions.questionData.filter((_, i) => i !== idx)
      await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify(updatedQuestions))
    } catch (error) {
      console.error('Error updating question data:', error)
    }
    GetFormDataForDiagnosis()
    setAllQuestions([])
    setDeleteVisible(false)
    SaveActivity('Deleted a question in Form Builder')
  }

  // const handleEditQuestion = (question, index) => {

  //   setSelectedEditDiagnosisQuestion(question)
  //   setSelectedEditDiagnosisQuestionIndex(index)
  //   mode.current = "Edit"
  //   setIsOpenModal(true)
  // }
  const handleEditQuestion = (question, index, isHeaderEdit = false) => {
    const updateNestedQuestion = (questions, index, updatedQuestion) => {
      return questions.map((ques, idx) => {
        if (idx === index) {
          return updatedQuestion
        }
        if (ques.linkedQuestion) {
          const linkedQuesArray = Array.isArray(ques.linkedQuestion) ? ques.linkedQuestion : [ques.linkedQuestion]
          return {
            ...ques,
            linkedQuestion: updateNestedQuestion(linkedQuesArray, index, updatedQuestion),
          }
        }
        return ques
      })
    }

    const updatedQuestions = updateNestedQuestion(fetchedQuestions.questionData, index, question)

    setFetchedQuestions((prev) => ({
      ...prev,
      questionData: updatedQuestions,
    }))
    setSelectedEditDiagnosisQuestion(question)
    setSelectedEditDiagnosisQuestionIndex(index)
    mode.current = 'Edit'
    if (isHeaderEdit) {
      setEditHeaderPluginValue(question || {})
      setShowHeaderModel(true)
    } else {
      setIsOpenModal(true)
    }
  }

  const GetCopyQuestion = async () => {
    let formattedData
    formattedData = await SaveQuestionProvider('GET', '', copyType.value, copyDiagnosis?.value?.toString(), '')

    if (formattedData) {
      formattedData = JSON.parse(formattedData.d)?.Data || []
      formattedData = formattedData[0] || []
      if (formattedData.questionData) {
        formattedData = {
          ...formattedData,
          questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
        }
      }

      setFetchCopyQuestion(formattedData)
    }
  }

  const generateId = () => Date.now() + Math.floor(Math.random() * 100000)

  const regenerateIds = (question) => {
    const newQuestion = {
      ...question,
      id: generateId(),
    }

    // Update options
    if (Array.isArray(newQuestion.options)) {
      newQuestion.options = newQuestion.options.map((opt) => {
        const newOption = {
          ...opt,
          id: generateId(),
        }

        // Handle linked questions inside options
        if (Array.isArray(opt.linkedQuestion)) {
          newOption.linkedQuestion = opt.linkedQuestion.map((lq) => regenerateIds(lq))
        }

        return newOption
      })
    }

    return newQuestion
  }

  const handleCopySubmit = async () => {
    // await GetCopyQuestion()
    // let questionData = selectedCopyOptions.map((item, index) => item.data)
    let questionData = selectedCopyOptions.map((item) => regenerateIds(item.data))
    if (fetchCopyQuestion && fetchCopyQuestion.questionData.length > 0 && selectComponentType.value && selectedDiagnosis?.value) {
      if (fetchedQuestions.length === 0) {
        await SaveQuestionProvider('INSERT', '', selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify(questionData))
      } else {
        await SaveQuestionProvider('UPDATE', fetchedQuestions.id.toString(), selectComponentType.value, selectedDiagnosis?.value?.toString(), JSON.stringify([...fetchedQuestions.questionData, ...questionData]))
      }

      GetFormDataForDiagnosis()
    }
    setCopyDiagnosis(null)
    setCopyType(null)
    setCopyModelVisible(false)
    setSelectedCopyOptions([])
  }

  const transformQuestionDataToOptions = async () => {
    let formattedData
    formattedData = await SaveQuestionProvider('GET', '', copyType.value, copyDiagnosis?.value?.toString(), '')

    if (formattedData) {
      formattedData = JSON.parse(formattedData.d)?.Data || []
      formattedData = formattedData[0] || []
      if (formattedData.questionData) {
        formattedData = {
          ...formattedData,
          questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
        }
      }
      setFetchCopyQuestion(formattedData)
      let copyOption = formattedData.questionData.map((question) => ({
        value: question.id,
        label: question.label,
        data: question,
      }))

      setCopyOptions(copyOption)
    }
  }

  useEffect(() => {
    if (copyDiagnosis && copyType) {
      transformQuestionDataToOptions()
    }
  }, [copyDiagnosis, copyType])

  return (
    <>
      <CModal visible={deleteVisible} onClose={() => setDeleteVisible(false)}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p>Are you sure you want to delete?</p>
        </CModalBody>

        <CModalFooter>
          <CButton
            onClick={() => {
              setDeleteVisible(false)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={() => deleteQuestion(deleteQuestionIndex)} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>

      {/* model for copy  */}
      <CModal visible={copyModelVisible} onClose={() => setCopyModelVisible(false)}>
        <CModalHeader>
          <CModalTitle>Copy Question</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="mb-2 mx-auto w-75">
            <CFormLabel className="font-weight-bold" style={{ fontSize: '16px', fontWeight: '500' }}>
              Select Type
            </CFormLabel>
            <Select
              value={copyType}
              onChange={(e) => {
                setCopyType(e)
              }}
              options={componentOption}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
          <div className="mb-2 mx-auto w-75">
            <CFormLabel className="font-weight-bold" style={{ fontSize: '16px', fontWeight: '500' }}>
              Select Diagnosis
            </CFormLabel>
            <Select
              value={copyDiagnosis}
              onChange={(e) => {
                setCopyDiagnosis(e)
              }}
              options={diagnosisData}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
          <div className="mb-2 mx-auto w-75">
            <CheckOptionSelections
              options={copyOptions}
              selectedValue={selectedCopyOptions}
              setSelectedValue={setSelectedCopyOptions}
              // isPageLoading={isPageLoading}
              Label={'Select Question'}
            />
          </div>
        </CModalBody>

        <CModalFooter>
          <CButton
            onClick={() => {
              setCopyModelVisible(false)
            }}
            className=""
            color="secondary"
            variant="outline"
          >
            Close
          </CButton>
          <CButton onClick={handleCopySubmit} color="primary" className="text-white">
            Copy
          </CButton>
        </CModalFooter>
      </CModal>

      <div className="custom-form-builder-theme d-flex flex-column flex-md-row justify-content-between text-small" style={{ width: '90vw', minHeight: '100vh' }}>
        <div className="px-1 px-sm-5" style={{ width: isMobile ? '100%' : '45%' }}>
          <CCard title="Diagnosis" className="custom-form-builder-theme__card my-4 shadow-sm">
            <CCardHeader className="custom-form-builder-theme__card-header text-center p-2">
              <CCardTitle className="custom-form-builder-theme__card-title font-weight-bold mb-0">
                Select Diagnosis For <span>{selectComponentType.value}</span> Questions
              </CCardTitle>
            </CCardHeader>
            <CCardBody className="custom-form-builder-theme__card-body rounded">
              <div className="mb-2 mx-auto w-75">
                <CFormLabel className="custom-form-builder-theme__label font-weight-bold">Select Type</CFormLabel>
                <Select
                  value={selectComponentType}
                  onChange={(e) => {
                    setSelectComponentType(e)
                  }}
                  options={componentOption}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
              <div className="mb-2 mx-auto w-75">
                <CFormLabel className="custom-form-builder-theme__label font-weight-bold">Select Diagnosis</CFormLabel>
                <Select
                  value={selectedDiagnosis}
                  onChange={(e) => {
                    setSelectedDiagnosis(e)
                  }}
                  options={diagnosisData}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
            </CCardBody>
            {/* <CCardFooter  className="d-flex justify-content-between align-items-center" style={{ border: '', background: 'white' ,  }}>
                  

           {componentType?.value === 'Call Center'   ? <div className="d-flex  gap-2 ">
                  <CButton variant="outline" onClick={() => setCopyModelVisible(true)} color="primary" style={{ width: '130px' , height:'40px' , fontSize:'14px' }}  >
                  Copy Question
                </CButton>
                   <CButton onClick={() => {setShowHeaderModel(true), setPluginType('Header')}} variant="outline" color="primary"  style={{ width: '130px' , height:'40px' , fontSize:'12px' }}  >
                  Add Header
                </CButton>
                 <CButton onClick={() => {setShowHeaderModel(true), setPluginType('subHeader')}} variant="outline" color="primary"   style={{ width: '130px' , height:'40px' , fontSize:'12px' }}  >
                  Add Sub Header
                </CButton>

                <CButton
                  onClick={() => {
                    setSelectedEditDiagnosisQuestion(null)
                    setQuestionType('')
                    mode.current = 'Add'
                    setIsOpenModal(true)
                  }}
                  style={{
                    width: '130px' , height:'40px' , fontSize:'12px',
                    borderColor: selectedDiagnosis === null ? '#321fdb' : undefined,
                    color: selectedDiagnosis === null ? '#321fdb' : undefined,
                    opacity: selectedDiagnosis === null ? 0.5 : undefined
                  }}
                  variant="outline"
                  color="primary"
                  disabled={selectedDiagnosis === null}
                  size="sm"
                >
                  Add Questions
                </CButton>

              </div> :  
               <div className="d-flex justify-content-between border "  >
                  <CButton variant="outline" onClick={() => setCopyModelVisible(true)} color="primary" style={{ width: '130px' , height:'40px' , fontSize:'14px' }}  >
                  Copy Question
                </CButton>
            
                  <CButton
                    onClick={() => {
                      setSelectedEditDiagnosisQuestion(null)
                      setQuestionType('')
                      mode.current = 'Add'
                      setIsOpenModal(true)
                    }}
                    style={{
                      width: '130px' , height:'40px' , fontSize:'12px',
                      borderColor: selectedDiagnosis === null ? '#321fdb' : undefined,
                      color: selectedDiagnosis === null ? '#321fdb' : undefined,
                      opacity: selectedDiagnosis === null ? 0.5 : undefined
                    }}
                    variant="outline"
                    color="primary"
                    disabled={selectedDiagnosis === null}
                    size="sm"
                  >
                    Add Questions
                  </CButton>

              </div>}

              
            </CCardFooter> */}
            <CCardFooter className="custom-form-builder-theme__card-footer d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2">
                <CButton variant="outline" onClick={() => setCopyModelVisible(true)} color="primary" className="custom-form-builder-theme__action-btn" style={{ width: '130px', height: '40px', fontSize: '14px' }}>
                  Copy Question
                </CButton>

                {componentType?.value === 'Call Center' && (
                  <>
                    <CButton
                      onClick={() => {
                        setShowHeaderModel(true)
                        setPluginType('Header')
                      }}
                      variant="outline"
                      color="primary"
                      className="custom-form-builder-theme__action-btn"
                      style={{ width: '130px', height: '40px', fontSize: '12px' }}
                    >
                      Add Header
                    </CButton>

                    <CButton
                      onClick={() => {
                        setShowHeaderModel(true)
                        setPluginType('subHeader')
                      }}
                      variant="outline"
                      color="primary"
                      className="custom-form-builder-theme__action-btn"
                      style={{ width: '130px', height: '40px', fontSize: '12px' }}
                    >
                      Add Sub Header
                    </CButton>
                  </>
                )}
              </div>

              <div style={{ marginLeft: componentType?.value === 'Call Center' ? '-25px' : '' }}>
                <CButton
                  onClick={() => {
                    setSelectedEditDiagnosisQuestion(null)
                    setQuestionType('')
                    mode.current = 'Add'
                    setIsOpenModal(true)
                  }}
                  style={{
                    width: '130px',
                    height: '40px',
                    fontSize: '12px',
                    borderColor: selectedDiagnosis === null ? '#321fdb' : undefined,
                    color: selectedDiagnosis === null ? '#321fdb' : undefined,
                    opacity: selectedDiagnosis === null ? 0.5 : undefined,
                  }}
                  variant="outline"
                  color="primary"
                  className="custom-form-builder-theme__action-btn"
                  disabled={selectedDiagnosis === null}
                  size="sm"
                >
                  Add Questions
                </CButton>
              </div>
            </CCardFooter>
          </CCard>
        </div>

        <div className="container-fluid" style={{ width: isMobile ? '100%' : '50%' }}>
          <div className="custom-form-builder-theme__selected-diagnosis text-center py-1 rounded shadow-sm fs-5 fw-bold">{selectedDiagnosis && selectedDiagnosis?.label}</div>

          <div className="custom-form-builder-theme__instruction p-2 mt-2 border-bottom shadow-sm">
            {' '}
            <span className="mx-2">
              <ListOrdered size={20} strokeWidth={1.5} />
            </span>{' '}
            Drag & Drop For Reordering Questions.
          </div>
          <div
            className="custom-form-builder-theme__question-panel p-3 rounded shadow-sm overflow-auto"
            style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(1, 1fr)', gap: '1rem', maxHeight: '90vh', overflow: 'auto' }}
          >
            <div>
              {fetchedQuestions.questionData && (
                <DisplayQuestion fetchedQuestions={fetchedQuestions} handleDragStart={handleDragStart} handleDragOver={handleDragOver} handleDrop={handleDrop} handleEditQuestion={handleEditQuestion} setDeleteVisible={setDeleteVisible} setDeleteQuestionIndex={setDeleteQuestionIndex} />
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalFormBuilder
        mode={mode}
        newQuestions={newQuestions}
        setNewQuestions={setNewQuestions}
        fetchedQuestions={fetchedQuestions}
        setFetchedQuestions={setFetchedQuestions}
        selectedEditDiagnosisQuestion={selectedEditDiagnosisQuestion}
        selectedEditDiagnosisQuestionIndex={selectedEditDiagnosisQuestionIndex}
        allQuestions={allQuestions}
        setAllQuestions={setAllQuestions}
        setIsOpenModal={setIsOpenModal}
        isOpen={isModalOpen}
        onClose={() => setIsOpenModal(false)}
        setSelectedEditDiagnosisQuestion={setSelectedEditDiagnosisQuestion}
        addFormMade={addFormMade}
        setCallAddFromMade={setCallAddFromMade}
        diagnosisData={diagnosisData}
        selectedDiagnosis={selectedDiagnosis}
        questionType={questionType}
        setQuestionType={setQuestionType}
      />

      {showHeaderModel && (
        <Suspense
          fallback={
            <div>
              <Spinner />
            </div>
          }
        >
          <HeaderPlugin showHeaderModel={showHeaderModel} setShowHeaderModel={setShowHeaderModel} addFormMade={addFormMade} editInputValue={editHeaderPluginValue} pluginType={pluginType} setPluginType={setPluginType} />
        </Suspense>
      )}
      <CModal
        size="lg"
        onClose={() => {
          setViewQuestions(false)
        }}
        visible={viewQuestions}
      >
        <CModalHeader closeButton>
          <CModalTitle>Preview Form</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="custom-form-builder-theme">
            <div
              className="custom-form-builder-theme__preview-grid p-2 d-flex flex-column gap-4"
              style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(1, 1fr)', gap: '1rem', maxHeight: '60vh', overflow: 'auto' }}
            >
              {fetchedQuestions.questionData &&
                fetchedQuestions.questionData.map((ques, idx) => (
                  <div
                    key={idx}
                    draggable
                    onDragStart={(e) => handleDragStart(e, idx)}
                    onDrop={(e) => handleDrop(e, idx)}
                    onDragOver={handleDragOver}
                    className={`custom-form-builder-theme__preview-card d-flex flex-column gap-3 p-3 mb-3 ${
                      ques?.type === 'input' && (ques?.condition === 'null' || !ques?.condition || ques?.condition?.multipleOptions?.includes(inputValues[ques?.condition?.questionId]))
                        ? 'visible'
                        : ques?.type === 'dropdown' && (!ques?.condition || (ques?.condition?.isShowOnCondition && ques?.condition?.multipleOptions?.includes(inputValues[ques?.condition?.questionId])))
                          ? 'visible'
                          : 'invisible d-none'
                    }`}
                    style={{ cursor: 'move', height: 'auto', borderRadius: '20px', maxWidth: '100%' }}
                  >
                    {ques?.type === 'input' ? (
                      <div className="d-flex flex-column gap-2 ">
                        <div className="d-flex justify-content-between align-items-center ">
                          <label className="fw-bold  " style={{ maxWidth: '400px' }}>
                            {ques?.label}
                          </label>
                          <CTooltip content={ques?.toolTipValue ? ques?.toolTipValue : 'Add the tooltip'}>
                            <Info size={16} />
                          </CTooltip>
                        </div>
                        {ques?.isTextArea ? (
                          <textarea value={inputValues[ques?.id]} onChange={(e) => handleInputChange(e, ques?.id)} placeholder="Enter your answer here..." className="form-control" rows="4" />
                        ) : (
                          <input type="text" onChange={(e) => handleInputChange(e, ques?.id)} value={inputValues[ques?.id]} placeholder="Enter your answer here..." className="form-control" />
                        )}
                      </div>
                    ) : (
                      // Dropdown Field
                      <div className={`d-flex flex-column gap-2    ${ques?.type === 'dropdown' && (!ques?.condition || (ques?.condition?.isShowOnCondition && ques?.condition?.multipleOptions?.includes(inputValues[ques?.condition?.questionId]))) ? 'visible' : 'invisible d-none'}`}>
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="fw-bold  " style={{ maxWidth: '400px' }}>
                            {ques?.label}
                          </label>
                          <CTooltip content={ques?.toolTipValue ? ques?.toolTipValue : 'Add the tooltip'}>
                            <Info size={16} />
                          </CTooltip>
                        </div>
                        <Select
                          multiple={ques?.isMultiple}
                          options={ques?.options}
                          onChange={(e) => {
                            setInputValues((prev) => ({
                              ...prev,
                              [ques?.id]: e.label,
                            }))
                          }}
                          className="basic-single-select"
                          classNamePrefix="select"
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton onClick={() => setViewQuestions(false)} color="secondary">
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default CustomFormBuilder
